import Model from '../../models/scoopm/Estimate';
import Trip from '../../models/scoopm/Trip';
import HttpReference from '../platform/HttpReference';

export default class Estimate extends HttpReference {
  create(trip: Trip) {
    return this.request<Model>({method: 'POST', data: trip});
  }
}
